import { AType } from "@silversea-ssc/functional-support"
import { NonEmptyString as IoTsNonEmptyString } from "io-ts-types"
import { brandString } from "./brand-string"
import * as Schema from "effect/Schema"
import * as Arbitrary from "effect/Arbitrary"
import * as F from "effect/Function"

//TODO once NonEmptyStringV2 is used in the codebase:
// 1. make NonEmptyString private
// 2. derive the type from NonEmptyStringV2
// 3. remove NonEmptyString
export const NonEmptyString = /* @__PURE__ */ brandString(IoTsNonEmptyString, ({ string }) => string({ minLength: 1 }))
export type NonEmptyString = AType<typeof NonEmptyString>
const filterNonEmptyStringForBetterTreeShaking = (x: string) => NonEmptyString.strictType.is(x)
export const NonEmptyStringV2 = /* @__PURE__ */ F.pipe(
    /* @__PURE__ */ Schema.String,
    /* @__PURE__ */ Schema.filter(filterNonEmptyStringForBetterTreeShaking, {
        identifier: "NonEmptyString",
        arbitrary: (): Arbitrary.LazyArbitrary<NonEmptyString> => (fc) =>
            fc.string({ minLength: 1 }).map((x) => x as NonEmptyString),
    }),
)
